export const updateDisplayTargeting = creative => ({
  ...creative,
  displayTargeting: creative.displayTargeting ?? 'web',
});
